/* eslint-disable import/no-cycle */
import moment from 'moment-timezone';
import * as _ from '../lodash';
import Translation from '../utilities/localizationUtility';
import {
  parseTime as parseTime1,
  isValidDate,
  isValidISOFormat,
} from './timeUtility';

export const prefixZero = (string, size) => {
  let s = `${string}`;
  while (s.length < size) s = `0${s}`;
  return s;
};

export const capitalize = value => _.capitalize(value);

export const parseInt = value => (+value ? +value : 0);

export const findProp = (props, names, options = false) => {
  if (!props) return false;

  const keys = Object.keys(props);
  for (let x = 0; x < keys.length; x++) {
    for (let y = 0; y < names.length; y++) {
      if (keys[x].toLowerCase().indexOf(names[y]) === 0 && keys[x].length === names[y].length) {
        if (!options || !options.type) {
          return props[keys[x]];
        }

        const { type } = options;
        switch (type) {
          case 'date':
            if (options.format) {
              if (isValidDate(props[keys[x]], options.format)) {
                return props[keys[x]];
              }
            }
            if (isValidISOFormat(props[keys[x]])) {
              return props[keys[x]];
            }
            break;
          case 'time':
            if (parseTime1(props[keys[x]]).isValid()) {
              return props[keys[x]];
            }
            break;
          default:
            break;
        }
      }
    }
  }

  return false;
};

export const formatAvailabilityMessage = (available, total, translation = new Translation({})) => {
  let message;

  const template = translation.key('textForShownReminingPlaces') || '{{spaces_count}}',
        space = translation.key('oneSpace') || 'space',
        spaces = translation.key('multipleSpaces') || 'spaces',
        soldOut = translation.key('soldOut') || 'Sold out';

  if (available <= 0) {
    message = soldOut;
  } else if (total > available) {
    message = `Only ${available} ${space}`;
  } else if (available == 1) {
    message = interpolateMessageToTemplate(template, `${available} ${space}`)
  } else {
    message = interpolateMessageToTemplate(template, `${available} ${spaces}`)
  }
  return message;
};

const interpolateMessageToTemplate = (template, value) => {
  let message;
  let _ = require("lodash").runInContext();

  _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;

  const templateFunc = _.template(template);

  try {
    message = templateFunc({'spaces_count': value})
  } catch {
    message = template
  }

  return message
}

export const parseTime = (message) => {
  let output = message;
  const utcDates = output.match(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z/g);
  if (utcDates) {
    utcDates.forEach((date) => {
      output = output.replace(date, moment.tz(date, window.bta.timeZone).format('LLL (z)'));
    });
  }
  return output;
};

export const findUnits = (item) => {
  const unitsNames = ['units', 'booking-party', 'booking-units'];
  const units = findProp(item.properties, unitsNames);
  if (units) {
    return ~~units;
  }

  return item.quantity;
};

export const flatten = (input, depth = 1, stack = []) => {
  for (let item of input)
  {
    if (item instanceof Array) {
      flatten(item, depth - 1, stack);
    }
    else {
      stack.push(item);
    }
  }

  return stack;
}

export const parseAvailableDates = (timeslots, minDate, maxDate, timeZone) => {
  const now = moment.tz(timeZone);
  const today = now.clone().startOf('day');
  const minDay = now.clone().add(minDate, 'seconds').startOf('day');
  const maxDay = now.clone().add(maxDate, 'days').startOf('day');
  return timeslots.reduce((arr, timeslot) => {
    const theDate = moment.tz(timeslot.date, timeZone);
    let isValid = false;
    if (timeslot.available_slot_count > 0) {
      if (theDate.isSameOrAfter(today)) {
        if (minDate) {
          if (theDate.isSameOrAfter(minDay)) {
            if (maxDate) {
              if (maxDay.isSameOrAfter(theDate)) {
                isValid = true;
              }
            } else {
              isValid = true;
            }
          }
        } else if (maxDate) {
          if (maxDay.isSameOrAfter(theDate)) {
            isValid = true;
          }
        } else {
          isValid = true;
        }
      }
    }


    if (isValid && _.find(timeslot.timeslots, x => moment.tz(x.start, timeZone).isSameOrAfter(now))) {
      arr.push(timeslot.date);
    }
    return arr;
  }, []);
};

export const customSelectStyles = (styles) => {
  return {
    option: (provided, state) => ({
      ...provided,
      ...styles
    }),
    singleValue: (provided, state) => ({
      ...provided,
      ...styles
    }),
    placeholder: (provided, state) => ({
      ...provided,
      ...styles
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      ...styles
    }),
    clearIndicator: (provided, state) => ({
      ...provided,
      ...styles
    })
  }
}
